/**
 * @returns true if authenticated
 */
export function checkIfAuth() {
  // This may be a little getto,
  // TODO auth with servers
  const tok = getToken()
  return tok !== null && tok !== undefined
}

export function getToken() {
  return BSGetCookie('token')
}

/**
 * 
 * @param {string} email 
 * @param {string} password 
 * @param {string} userType either 'ad-owner' or 'tv-owner'
 */
export async function login(email, password, userType) {
  try {
    const res = await BSFetch(`${userType}/user/log-in`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ email, password }),
      mode: "cors",
      cache: "no-cache"
    });
    if (res.status === 200) {
      const resBody = await res.json();
      const authToken = resBody.response.token;
      const user = resBody.response.user;
      setCookiesAndRedirect(authToken, user, userType)
    } else {
      if (res.status === 401)
        return 'Incorrect email or password'
      else
        return 'There was an error in the login process, please try again later'
    }
  } catch (e) {
    return 'There was an error in the login process, please try again later'
  }
}

/**
 * 
 * @param {JSON} body req body
 * @param {string} userType either 'ad-owner' or 'tv-owner'
 */
export async function signUp(body, userType) {
  try {
    const res = await BSFetch(`${userType}/user/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body),
      mode: "cors",
      cache: "no-cache"
    });
    const resBody = await res.json();
    if (res.status === 200) {
      const authToken = resBody.response.token;
      const user = resBody.response.user;
      setCookiesAndRedirect(authToken, user, userType)
    } else {
      if (res.status === 400)
        return resBody.response.status
      return 'There was an error in creating your account, please try again later'
    }
  } catch (e) {
    return 'There was an error in creating your account, please try again later'
  }
}

function setCookiesAndRedirect(authToken, user, userType) {
  document.cookie = "token=" + authToken;
  document.cookie = "user=" + JSON.stringify(user);
  document.cookie = "userType="+userType;
  if (userType === 'ad-owner')
    window.location.href = "#/advertiser"
  else if (userType === 'tv-owner')
    window.location.href = "#/brite-host"
}

export async function logOut() {
  deleteAllCookies()
  window.location.reload()
}

function deleteAllCookies() {
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}